import React from 'react';
import PropTypes from 'prop-types';

import ImageCropped from 'views_shared/app/javascript/components/ImageCropped';

function ConversationProfileImages({ profiles, size = 52 }) {
  if (!profiles || profiles.length === 0) return null;

  const validProfiles = profiles.filter((p) => p && p.slug && p.profile_image_url);
  if (validProfiles.length === 0) return null;

  if (validProfiles.length === 1) {
    const profile = validProfiles[0];
    return (
      <ImageCropped
        roundedCircle
        src={profile.profile_image_url}
        alt={profile.name || ''}
        size={size}
        fallbackToInitials
      />
    );
  }

  const firstProfile = validProfiles[0];
  const overlap = Math.round(size * 0.3);
  const remainingCount = validProfiles.length - 1;

  return (
    <div className="d-flex align-items-center">
      <div style={{ zIndex: 2, position: 'relative' }}>
        <ImageCropped
          roundedCircle
          src={firstProfile.profile_image_url}
          alt={firstProfile.name || ''}
          size={size}
          className="border border-white border-2"
          fallbackToInitials
        />
      </div>
      {validProfiles.length === 2 ? (
        <div style={{ marginLeft: -overlap, zIndex: 1, position: 'relative' }}>
          <ImageCropped
            roundedCircle
            src={validProfiles[1].profile_image_url}
            alt={validProfiles[1].name || ''}
            size={size}
            className="border border-white border-2"
            fallbackToInitials
          />
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center rounded-circle bg-neutral-20 text-neutral-80 fw-bold border border-white border-2 paragraph-xs"
          style={{
            width: size,
            height: size,
            marginLeft: -overlap,
            position: 'relative',
            zIndex: 1,
          }}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  );
}

ConversationProfileImages.propTypes = {
  profiles: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
      profile_image_url: PropTypes.string,
    }),
  ).isRequired,
  size: PropTypes.number,
};

export default ConversationProfileImages;
